<template>
  <v-navigation-drawer class="nav">
    <v-list class="nav">
        <template v-for="(component, i) in list">
        <v-list-tile :key="`${i}`" :style="{'background-color': component.color ? component.color : ''}" class="white--text">
          <v-list-tile-title  :class="active === component.component ? 'accent--text' : ''" class="side-component" @click="() => selectComponent(component)">
            <v-icon v-if="component.icon" size="22" class="mr-2">arrow_back</v-icon>
            <span v-if="component.name">{{component.name}}</span>
          </v-list-tile-title>
          <v-divider></v-divider>
        </v-list-tile>
        </template>
    </v-list>
  </v-navigation-drawer>
</template>

<script>
import { mapActions } from 'vuex'

export default {
  props: {
    list: Array
  },
  data() {
    return {
      active: ''
    }
  },
  mounted() {
    this.active = this.list[1].component
    // const {component} = componentList[0]
    // this.$emit('component:update', {
    //   component
    // })
  },
  methods: {
    ...mapActions('admin', ['setActiveComponent']),
    selectComponent(component) {
      // this.setActiveComponent(component)
      this.active = component.component === 'back' ? this.list[1].component : component.component
      this.$emit('component:update', component)
    }
  },
  watch: {
    list: () => {
      this.active = this.list[1].component
    }
  }
}
</script>

<style scoped>
.side-component{
  cursor: pointer;
}
</style>